import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=37deb53e&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&async=true&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=37deb53e&lang=scss&scoped=true&"
import style1 from "./PersonalDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37deb53e",
  null
  
)

export default component.exports